export default __webpack_public_path__ + "static/media/devgif.4492d864.gif";